module.exports = __webpack_public_path__ + "static/fipcnavybear2-e4740f6f0487a2fd84fba61e25dc3d97.jpeg";